<template>
    <div v-if="ready" id="registration-landing-container">
    <v-container grid-list-lg>
        <v-layout row>
            <v-flex xs12 class="text-xs-center display-1 font-weight-black my-5">Current OFB Plans</v-flex>
            <div>All plans are per user except for Server Premium and Webhooks. (Coming soon)</div>
            <br>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm12 md4>
                <v-card height="100%" elevation="11" :style="'border: 3px solid grey'">
                    <v-responsive>
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>

                                    <span class="headline grey--text">Basic </span>
                                    <span class="headline grey--text"> - FREE</span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-responsive>
                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">Features </h3>
                            <li v-for="freeStuff in freeStuffs" :key="freeStuff.message">
                                {{ freeStuff.message }}
                            </li>
                            <br />
                            <div>The Free OFB Plan. Everyone starts here.
                            </div>
                        </div>
                        <br />
                        <br>
                    </v-card-text>
                    <v-card-actions class="card-actions">
                        <v-btn disabled="true" outlined block color="grey" @click="tierSelected('OF_T2')">Current Plan</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-card height="100%" elevation="11" :style="'border: 3px solid green'">
                    <v-responsive>
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>

                                    <span class="headline green--text">Standard</span>
                                    <span class="headline green--text"> - $5/mo</span>

                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-responsive>
                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">Features </h3>
                            <li v-for="standardStuff in standardStuffs" :key="standardStuff.message">
                                {{ standardStuff.message }}
                            </li>
                            <br />
                            <div>Standard OFB Plan. Gives you unlimited commands for any server you are in throughout Discord.
                            </div>
                        </div>
                        <br />
                        <br />
                    </v-card-text>
                    <v-card-actions class="card-actions">
                        <v-btn outlined block color="green" @click="tierSelected('OF_T1')">Select This Plan</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-card height="100%" elevation="11" :style="'border: 3px solid blue'">
                    <v-responsive>
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline blue--text">Premium</span>
                                    <span class="headline blue--text"> - $20/mo</span>

                                </v-flex>
                                <v-img
                                        class="ml-auto"
                                        max-height="50px"
                                        max-width="50px"
                                        src="/assets/best.png"
                                >
                                </v-img>
                            </v-layout>
                        </v-container>
                    </v-responsive>
                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">Features </h3>
                            <li v-for="premiumStuff in premiumStuffs" :key="premiumStuff.message">
                                {{ premiumStuff.message }}
                            </li>
                            <br />
                            <div>Our Premium Membership. Gives you everything in Standard plus access to our Options Flow (realtime), Crypto (realtime), and Dark Pool (15m Delayed).
                            </div>
                        </div>
                        <br />
                        <br />
                        <br />
                    </v-card-text>
                    <v-card-actions class="card-actions">
                        <v-btn outlined block color="blue" @click="tierSelected('OF_T2')">Select This Plan</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-card height="100%" elevation="11" :style="'border: 3px solid yellow'">
                    <v-responsive>
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline yellow--text">Server</span>
                                    <span class="headline yellow--text"> - $149.99/mo</span>

                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-responsive>
                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">Features </h3>
                            <li v-for="serverStuff in serverStuffs" :key="serverStuff.message">
                                {{ serverStuff.message }}
                            </li>
                            <br />
                            <div>Our Premium Server Plan. Gives your discord server access to the premium version of OFB.
                            </div>
                        </div>
                        <br />
                        <br />
                        <br />
                    </v-card-text>
                    <v-card-actions class="card-actions">
                        <v-btn outlined block color="yellow" @click="tierSelected('OF_T3')">Select This Plan</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    </div>
    <div id="loading-container" v-else>
        <v-overlay
                :value="!ready"
                absolute
        >
            <div id="loading-overlay">
                <v-progress-circular
                        :size="70"
                        :width="7"
                        color="purple"
                        indeterminate
                ></v-progress-circular>
                <span id="loading-text"><i>{{easterEggs[Math.floor(Math.random() * easterEggs.length)]}}</i></span>
            </div>
        </v-overlay>
    </div>
</template>

<script>
    import {BASE_URL} from "../../utils/constants"
    import {COOKIE_USER_AUTH, COOKIE_USER_ID, setCookieWithMonthExpiry} from "../../utils/CookieHelper";
    import {AUTH} from "@/firebase/config";
    import FeatureList from "../../features.json";

    const ENDPOINT = "api/v1/discord/oauth"

    export default {
        created() {
            let discordCode = this.$route.query.code ? this.$route.query.code : ""
            this.parseQueryString(discordCode)
            this.exchangeCodes(discordCode)
        },
        name: "RegistrationLanding",
        methods: {
            parseQueryString: function (discordCode){
                if (discordCode.length < 1) {
                    this.$router.push({name: "Login"})
                }
            },
            exchangeCodes: async function(discordCode) {

                fetch(BASE_URL + ENDPOINT + "?code=" + discordCode, {method: 'post'})
                    .then(response => {
                        this.parseResponse(response)

                    })
                    .catch(error => {
                        alert(error)
                        this.$router.push({name: "Login"})
                    })
            },

            parseResponse: function(response) {

                if (response.status === 200 || response.status === 301) {
                    response.json().then(respData => {

                        // This means user is not registered, so they must continue on with the registration process
                        if (response.status === 200) {
                            this.userInfo = {
                                username: `${respData.message.username}#${respData.message.discriminator}`,
                                avatar: `https://cdn.discordapp.com/avatars/${respData.message.id}/${respData.message.avatar}.jpg`,
                                userID: respData.message.id,
                                userEmail: respData.message.email,
                            }
                        }

                        // Set cookies with userID and userAuthToken for later use
                        setCookieWithMonthExpiry(COOKIE_USER_AUTH, respData.token)
                        setCookieWithMonthExpiry(COOKIE_USER_ID, respData.message.id)

                        //console.log(getCookie(COOKIE_USER_AUTH));





                        AUTH.signInWithCustomToken(respData.fbtoken)
                            .then((userCredential) => {
                                // Signed in
                                const user = userCredential.user;
                                console.log(user);
                                // ...
                            })
                            .catch((error) => {
                                const errorCode = error.code;
                                const errorMessage = error.message;
                                console.log(errorCode);
                                console.log(errorMessage);
                                // ...
                            });

                        // This means the user IS registered, so instead they get sent back to dashboard after the cookies are set
                        if (response.status === 301) {
                            this.$router.push({name: "DashMain"})
                        }
                        this.ready = true;
                    })
                } else {
                    alert("There was an error with your request, please try again later")
                    //Send Back
                    this.$router.push({name: "Login"})
                }

            },

            tierSelected: function(tier) {
                console.log(tier);
                console.log(this.userInfo.userID);
                console.log(this.userInfo.userEmail);
                this.$router.push({name: "Payment",  params: {selectedTier: tier, userID: this.userInfo.userID, userEmail: this.userInfo.userEmail, avatar:this.userInfo.avatar}})
            },
            webhookSelected: function() {
                this.$router.push({name: "WebhooksLanding",  params: {userID: this.userInfo.userID, userEmail: this.userInfo.userEmail, avatar:this.userInfo.avatar}})
            },
        },

        data: () => ({
            features: FeatureList,
            freeStuffs:[
                {"message": "Small Delay on all commands"},
                {"message": "Ads on most commands"},
                {"message": "Limited to 15 Dark Pool / Options commands a month"}
            ],
            standardStuffs:[
                {"message": "No Cooldown on All Options/Dark Pool Commands"},
                {"message": "Ad Free When You Run a Premium Command (Options and Dark Pool)"},
                {"message": "Unlimited Premium Commands Per Month"}
            ],
            premiumStuffs:[
                {"message": "No Cooldown on All Options/Dark Pool Commands"},
                {"message": "Ad Free When You Run a Premium Command"},
                {"message": "Unlimited Premium Commands Per Month"},
                {"message": "Access Options and Dark Pool Flow on Site"}
            ],
            serverStuffs:[
                {"message": "Small Cooldown on all commands"},
                {"message": "Ad Free on most commands"},
                {"message": "Unlimited Premium Commands Per Month in your server for all users"}
            ],
            tiers: [
                             {
                                 index: 0,
                                 title: "OFB Free",
                                 subtitle: "Current Subscription for anyone using OFB without a plan.",
                                 // make this T1 if you put it back - making it T2 incase someone accidently picks it.
                                 id: "OF_Free",
                                 price: "$5/mo",
                                 color: "#2180CE",
                                 description: "OptionsFamBot Membership - Discord Only"
                             },
                             {
                                 //make this index 1 if you add back in tier 1
                                 index: 1,
                                 title: "OFB Standard",
                                 subtitle: "Current Subscription for anyone using OFB without a plan.",
                                 id: "OF_T1",
                                 price: "$20/mo",
                                 color: "#BBA801",
                                 description: "OFBot Premium with Dark Pool and Options Flow on site"
                             },
                             {
                                 //make this index 1 if you add back in tier 1
                                 index: 2,
                                 title: "OFB Flow and Darkpool",
                                 subtitle: "Current Subscription for anyone using OFB without a plan. Users get 15 Free commands a month for DarkPool and Options Data.",
                                 id: "OF_T2",
                                 price: "$20/mo",
                                 color: "#BBA801",
                                 description: "OFBot Premium with Dark Pool and Options Flow on site"
                             },
                            {
                                //make this index 1 if you add back in tier 1
                                index: 3,
                                title: "OFB Server Premium",
                                subtitle: "Current Server Sub",
                                id: "OF_T3",
                                price: "$149.99/mo",
                                color: "#33bb01",
                                description: "OFBot Server Premium with unlimited commands on the Discord Server for all users."
                            },
                         ],
            ready: true,
            easterEggs: [
                "Wondering when $TSLA will crash...",
                "Wondering when $GME will crash...",
                "Wondering when $AMC will crash...",
            ],
            userInfo: {}
        }),
    }
</script>

<style scoped>
    h2 {
        margin-bottom: 1rem;
    }

    #loading-container {
        height: 100vh;
        width: 100vw;
    }

    #loading-overlay {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    #loading-text {
        margin-top: 2rem;

    }

    #registration-landing-container {
        width: 100%;
        height: 100%;
        padding: 16px 16px 10px 16px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }

    #user-info {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    #user-name {
        margin-right: 1rem;
    }

    #content-wrapper {
        height: 90%;
    }

    #join-tier {
        width: 100%;
        margin-top: 2rem;
    }

    #selection-carousel {
        margin: 1rem 0;
    }

    #features-table {
        background-color: #404040;
        box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
    }
    .media{
        border-radius:3%;
    }
    .media:hover{
        box-shadow: 0 0 3pt 2pt #ff5555;
        border-radius:3%;
        cursor: pointer;
    }
    .card-actions {
        position: absolute;
        bottom: 0;
    }
    .text{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: default;
        width: 100%;
        position: absolute;
    }
    .block{
        display: block !important;
        height: 104px;
    }

    @media screen and (min-width: 750px) {
        h1 {
            display: none;
        }

        #content-wrapper {
            width: 50%;
            max-width: 564px;
            margin: auto;
            height: fit-content;
            background-color: #404040;
            padding: 32px;
            border-radius: 10px;
            box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
        }
    }
</style>